<template>
  <v-app>
    <v-main>
      <v-container fill-height>
        <v-layout
          row
          wrap
        >
          <v-flex xs12> </v-flex>
          <v-flex
            xs12
            class="mx-5 text-xs-center"
            justify="center"
          >
            <a
              :href="appUrl"
              target="_blank"
              ><img
                :src="appLogo"
                :alt="appName"
                height="70px"
            /></a>

            <h1 class="display-1 primary--text">{{ $t("commons.ty") }}</h1>
            <br />
            <p class="headline">{{ $t("messages.information.confirmation_sent") }}</p>
            <p class="headline">
              {{ $t("views.signup_in.check_email") }}
            </p>
            <br />
            <h3 class="title mt-3">
              {{ $t("views.signup_in.confirm_email") }}
              <v-btn
                text
                depressed
                class="primary--text"
                href="/signin"
                >{{ $t("commons.click") }}</v-btn
              >
            </h3>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import AccountService from "@/services/AccountService"

export default {
  data() {
    return {
      appLogo: this.$appConfig.assets.img.custom.logo,
      appName: this.$appConfig.name.full,
      appUrl: this.$appConfig.url
    }
  },
  methods: {
    initialize() {
      const key = this.$route.params.key
      if (key) {
        // Email Validation
        AccountService.registerEmailValidation(this, key)
          .then(result => {
            this.$store.commit("app/success", this.$t("messages.success.email_activated"))
            this.$router.push({ name: "SignIn" })
          })
          .catch(error => {
            this.$store.commit("app/message", { msg: error, color: "warning" })
          })
      }
    }
  },
  mounted() {
    this.initialize()
  }
}
</script>
